import { useTranslation } from "react-i18next";
import CategoryDropdown from "@/components/base/CategoryDropdown";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center pt-20 pb-16 px-4 md:px-6">
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20flat%20lay%20composition%20of%20diverse%20fashion%20items%20including%20sneakers%20and%20accessories%20and%20fabric%20swatches%20scattered%20elegantly%20on%20warm%20cream%20linen%20surface%2C%20soft%20natural%20morning%20light%20streaming%20from%20left%2C%20gentle%20shadows%2C%20minimalist%20aesthetic%2C%20textured%20background%2C%20no%20text%20no%20logos%2C%20luxury%20fashion%20still%20life%20photography&width=1800&height=1200&seq=hero-bg-v2-cssbuy&orientation=landscape"
          alt="CSSBuy Spreadsheet fashion collection background"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/70 to-background-50/95"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto flex flex-col items-center text-center">
        {/* Category Dropdown */}
        <div className="mb-8 w-full max-w-md">
          <CategoryDropdown />
        </div>

        {/* Main Title */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-foreground-950 leading-tight mb-4">
          {t("hero.title.first")}
          <br />
          <span className="text-primary-600">{t("hero.title.second")}</span>
        </h1>

        {/* Subtitle */}
        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mb-10 leading-relaxed">
          {t("hero.subtitle")}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mb-14">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t("hero.cta.spreadsheet")}
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-transparent text-foreground-800 border border-foreground-300/60 rounded-full font-medium text-sm hover:border-foreground-400 hover:text-foreground-950 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t("hero.cta.links")}
            <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
            Atualizado diariamente
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
            Links revisados
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
            Guias seguros
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
            Sem cadastro
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
            Informações gratuitas
          </span>
        </div>
      </div>
    </section>
  );
}